import { render, staticRenderFns } from "./CCSftpConfiguration.vue?vue&type=template&id=5f4aff9e"
import script from "./CCSftpConfiguration.vue?vue&type=script&lang=js"
export * from "./CCSftpConfiguration.vue?vue&type=script&lang=js"
import style0 from "./CCSftpConfiguration.vue?vue&type=style&index=0&id=5f4aff9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports